
import axios from 'axios'
import { Message, SendMessagePayload } from 'src/core/models'

export async function getMessagesAPI(): Promise<Message[]> {
  const { data } = await axios.get('/api/v1/messages?page_size=99999')
  return data?.results
}

export async function sendMessageAPI(payload: SendMessagePayload): Promise<Message> {
  const { data } = await axios.post('/api/v1/messages/', payload)
  return data
}

export async function readMessageAPI(messageId: number): Promise<string> {
  const url = `/api/v1/messages/${messageId}/read/`
  const { data } = await axios.put(url, { read: true })
  return data
}
export async function getUserMessagesCountAPI(): Promise<number> {
  const { data } = await axios.get<{ count: number }>('/api/v1/messages/count?read=false')
  return data?.count
}
